/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './confirm-modal.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/modal/confirm-modal/confirm-modal.component';
import * as i3 from '../../svg-icon/svg-icon.component.ngfactory';
import * as i4 from '../../../../../app/shared/svg-icon/svg-icon.component';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../app/shared/translations/translations.service';
const styles_ConfirmModalComponent:any[] = [i0.styles];
export const RenderType_ConfirmModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ConfirmModalComponent,data:{}});
function View_ConfirmModalComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'bold']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.bodyBold;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ConfirmModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'backdrop']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          29,'div',[['class','modal-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['class','modal-header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'h2',[['class','modal-title']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),2,'button',[['class','close-button no-style icon-button'],
              ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ConfirmModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'svg-icon',[['name','close']],(null as any),(null as any),(null as any),
          i3.View_SvgIconComponent_0,i3.RenderType_SvgIconComponent)),i1.ɵdid(114688,
          (null as any),0,i4.SvgIconComponent,[i1.ElementRef,i1.Renderer2],{name:[0,
              'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','confirm-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ConfirmModalComponent_1)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','buttons right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'button',[['class','button cancel cancel-button'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.ConfirmModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'button',[['class','button primary submit-button'],['type','submit']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ConfirmModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.confirm()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i2.ConfirmModalComponent = _v.component;
        const currVal_1:any = 'close';
        _ck(_v,11,0,currVal_1);
        const currVal_3:any = _co.bodyBold;
        _ck(_v,20,0,currVal_3);
      },(_ck,_v) => {
        var _co:i2.ConfirmModalComponent = _v.component;
        const currVal_0:any = _co.title;
        _ck(_v,7,0,currVal_0);
        const currVal_2:any = _co.body;
        _ck(_v,17,0,currVal_2);
        const currVal_4:any = _co.cancel;
        _ck(_v,26,0,currVal_4);
        const currVal_5:any = _co.ok;
        _ck(_v,29,0,currVal_5);
      });
}
export function View_ConfirmModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'confirm-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_ConfirmModalComponent_0,
      RenderType_ConfirmModalComponent)),i1.ɵdid(49152,(null as any),0,i2.ConfirmModalComponent,
      [i1.ElementRef,i1.Renderer2,i6.Translations],(null as any),(null as any))],(null as any),
      (null as any));
}
export const ConfirmModalComponentNgFactory:i1.ComponentFactory<i2.ConfirmModalComponent> = i1.ɵccf('confirm-modal',
    i2.ConfirmModalComponent,View_ConfirmModalComponent_Host_0,{},{onShow:'onShow',
        onClose:'onClose',onDone:'onDone'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/modal/confirm-modal/confirm-modal.component.ngfactory.ts